<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt class="rateSeasongsTable" [value]="rateSeasons" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="rateSeasonId" selectionMode="single"
  [(selection)]="rateSeason" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="250" [rowsPerPageOptions]="[250,500,1000, 2000]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" [filters]="multiFiltersMeta" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true" [scrollable]="true" scrollHeight="800px">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      @if (!titleFontSize) {
        <h1 style="float: left;margin: 6px;">RateSeasons</h1>
      }
      @if (titleFontSize) {
        <h4 style="float: left;margin: 6px;">RateSeasons</h4>
      }
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        @if (!outlineNewButton && !isBulkEditing) {
          <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="onOpenFormAdd()">New RateSeason +</button>
        }
        @if (outlineNewButton && !isBulkEditing) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="onOpenFormAdd()">New RateSeason +</button>
        }
        @if (isBulkEditing) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="updateRatesInBulk()">Bulk Update</button>
        }
        <!-- <p-button class="btn-warning-custom" [outlined]="true" severity="danger" style="padding: 0.643rem 0.75rem !important;"
      (click)="generateRates()">Generate Rates for All Properties</p-button> -->
    </span>
  </div>
</ng-template>
<ng-template pTemplate="header">
  <tr class="tablefrozenColumns">
    @for (col of frozenColumns; track col) {
      <th pFrozenColumn [pSortableColumn]="col.field" [ngStyle]="{'width': '50px'}">
        {{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    }
    @for (col of columns; track col) {
      <th [pSortableColumn]="col.field" [ngStyle]="{'width': '50px'}">
        {{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    }
    <th [ngStyle]="{'width': 'auto'}"></th>
  </tr>
  @if (showFilter) {
    <tr class="tablefrozenColumns">
      <!-- Checkbox column  -->
      @if (isBulkEditing) {
        <th pFrozenColumn>
          <p-checkbox [(ngModel)]="selectAllSeasons" (onChange)="onSeasonSelectionAll()" [binary]="true"></p-checkbox>
        </th>
      }
      <th pFrozenColumn [ngStyle]="{'width': '50px'}">
        <p-multiSelect [style]="{'width':'50px','min-width':'100%'}" [options]="bucketNames" appendTo="body"
          (onChange)="pt.filter($event.value, 'RateBucketVO.name', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [filter]="true" filterBy="name"
          optionLabel="name" optionValue="value" [maxSelectedLabels]="1" selectedItemsLabel="{0} buckets">
        </p-multiSelect>
      </th>
      <th>
        <p-dropdown [style]="{'width':'50px','min-width':'100%'}" [options]="locations" appendTo="body"
          (onChange)="pt.filter($event.value, 'locationId', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="locationId"
          [value]="pt.filters['locationId'] ? pt.filters['locationId'].value : ''">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th pFrozenColumn [ngStyle]="{'width': '50px'}">
        <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
        <th pFrozenColumn [ngStyle]="{'width': '50px'}">
          <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
            (input)="pt.filter($event.target.value, 'startDate', 'in')">
          </th>
          <th pFrozenColumn [ngStyle]="{'width': '50px'}">
            <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
              (input)="pt.filter($event.target.value, 'endDate', 'in')">
            </th>
            <th [ngStyle]="{'width': 'auto'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listPriceAMT', 'in')">
            </th>
            <th [ngStyle]="{'width': 'auto'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listPriceAdjustAMT', 'in')">
            </th>
            <th [ngStyle]="{'width': 'auto'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listPriceAdjustPCT', 'in')">
            </th>
            <th [ngStyle]="{'width': 'auto'}">
              <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="categories" appendTo="body"
                (onChange)="pt.filter($event.value, 'category', 'in')" styleClass="p-column-filter"
                placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
                <ng-template let-option pTemplate="item">
                  <span>{{option.name}}</span>
                </ng-template>
              </p-dropdown>
            </th>
            <th [ngStyle]="{'width': 'auto'}">
              <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="rateBucketTypes" appendTo="body"
                (onChange)="pt.filter($event.value, 'type', 'in')" styleClass="p-column-filter"
                placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
                <ng-template let-option pTemplate="item">
                  <span>{{option.name}}</span>
                </ng-template>
              </p-dropdown>
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'floorRateManagerAMT', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'floorRateOwnerAMT', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'expectedOccupancyPCT', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'maxDiscountPCT', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'discountLookForwardDays', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'discountLookForwardHeadlineDays', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'discountLookForwardHeadlineMinNightsDays', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'minStayExpectedNTS', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'maxStayExpectedNTS', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'avgStayBySeasonNTS', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermGapMultiplierPCT', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermGapPenaltyPCT', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermGapMinNumNightsRevNTS', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'longTermGapMultiplierPCT', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'longTermGapPenaltyPCT', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'longTermGapEmptyMultiplierPCT', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'longTermGapEmptyPenaltyPCT', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'connectingFrontOrBackMultiplierPCT', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'connectingFrontAndBackMultiplierPCT', 'in')">
            </th>
            <th pFrozenColumn [ngStyle]="{'width': '50px'}">
              <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lengthOfStayDiscountFactorOffset', 'in')">
            </th>
          </tr>
        }
      </ng-template>
      <ng-template pTemplate="body" let-rateSeason>
        <tr [pSelectableRow]="rateSeason" class="tablefrozenColumns">
          @if (isBulkEditing) {
            <td pFrozenColumn>
              <p-checkbox [(ngModel)]="rateSeason.isSelected" (onChange)="onSeasonSelection(rateSeason)" [binary]="true"></p-checkbox>
            </td>
          }
          <td pFrozenColumn>{{rateSeason.rateBucketName}}</td>
          <td>{{Locations[rateSeason['locationId']] }}</td>
          <td pFrozenColumn>{{rateSeason.name}}</td>
          <td pFrozenColumn>{{rateSeason.startDate | date}}</td>
          <td pFrozenColumn>{{rateSeason.endDate | date}}</td>
          <td>{{rateSeason.listPriceAMT | currency : 'USD' : 'symbol' : '1.0-2'}}</td>
          <td>{{rateSeason.listPriceAdjustAMT | currency : 'USD' : 'symbol' : '1.0-2'}}</td>
          <td>{{rateSeason.listPriceAdjustPCT | percent}}</td>
          <td>{{categoryName(rateSeason)}}</td>
          <td>{{rateBucketType(rateSeason)}}</td>
          <td>{{rateSeason.floorRateManagerAMT | currency : 'USD' : 'symbol' : '1.0-2'}}</td>
          <td>{{rateSeason.floorRateOwnerAMT | currency : 'USD' : 'symbol' : '1.0-2'}}</td>
          <td>{{rateSeason.expectedOccupancyPCT | percent}}</td>
          <td>{{rateSeason.maxDiscountPCT | percent}}</td>
          <td>{{rateSeason.discountLookForwardDays| number:'1.2'}}</td>
          <td>{{rateSeason.discountLookForwardHeadlineDays| number:'1.2'}}</td>
          <td>{{rateSeason.discountLookForwardHeadlineMinNightsDays| number:'1.2'}}</td>
          <td>{{rateSeason.minStayExpectedNTS| number:'1.2'}}</td>
          <td>{{rateSeason.maxStayExpectedNTS| number:'1.2'}}</td>
          <td>{{rateSeason.avgStayBySeasonNTS| number:'1.2'}}</td>
          <td>{{rateSeason.shortTermGapMultiplierPCT | percent}}</td>
          <td>{{rateSeason.shortTermGapPenaltyPCT | percent}}</td>
          <td>{{rateSeason.shortTermGapMinNumNightsRevNTS| number:'1.2'}}</td>
          <td>{{rateSeason.longTermGapMultiplierPCT | percent}}</td>
          <td>{{rateSeason.longTermGapPenaltyPCT | percent}}</td>
          <td>{{rateSeason.longTermGapEmptyMultiplierPCT| number:'1.2'}}</td>
          <td>{{rateSeason.longTermGapEmptyPenaltyPCT | percent}}</td>
          <td>{{rateSeason.connectingFrontOrBackMultiplierPCT | percent}}</td>
          <td>{{rateSeason.connectingFrontAndBackMultiplierPCT | percent}}</td>
          <td>{{rateSeason.lengthOfStayDiscountFactorOffset}}</td>


          <td><span style="float:none">
            <a>
              <i class="pi pi-pencil" aria-hidden="true"
              style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(rateSeason)"></i>
            </a>
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>

